import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Classes, Events } from './constants';
import { fixMobileHover, getCookiesAllowed, initGTM, initLightboxes, isDisclaimerAccepted, isTouchScreen, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, sortAnimations, wait } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";


// ---------- Touch Screen ----------

if(isTouchScreen()) {
	$Elements.html.addClass('touchscreen');
}

// ---------- Fix VH ----------

$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
$Elements.window.trigger('resize');

// ---------- Mobile CTA → Contact Form ----------

let contactFormObserver = null;

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, async() => {

	// ---------- Fix Mobile Hover ----------

	fixMobileHover();

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.PageWrapper.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.PageWrapper.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target);
		}
	});

	$Elements.PageWrapper.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	initLightboxes()

	// ---------- Cookies ----------

	initGTM();

	if(!getCookiesAllowed()) {

		const cookies = document.querySelector('#cookies-allowed');

		if(cookies) {

			cookies.classList.remove(Classes.hidden);
			await wait(100);
			cookies.classList.add(Classes.show);

			$(cookies).on('click', '[data-bs-dismiss="alert"]', function() {
				setCookiesAllowed(this.dataset.allowed);
			});
		}
	}


	// ---------- Disclaimer ----------

	if(!isDisclaimerAccepted()) {

		const disclaimer = document.querySelector('#disclaimer');

		if(disclaimer) {

			disclaimer.classList.remove(Classes.hidden);
			$Elements.body.addClass(Classes.disclaimer);

			$(disclaimer).on('close.bs.alert', function() {
				setDisclaimerAccepted();
				$Elements.body.removeClass(Classes.disclaimer);
			});
		}
	}


	//------------- Thématique colors --------------

	const medicalColor = document.getElementById('page-wrapper').dataset.thematiqueMedical;
	const accidentsColor = document.getElementById('page-wrapper').dataset.thematiqueAccidents;
	const agressionsColor = document.getElementById('page-wrapper').dataset.thematiqueAgressions;
	const cabinetColor = document.getElementById('page-wrapper').dataset.thematiqueCabinet;
	const expositionsColor = document.getElementById('page-wrapper').dataset.thematiqueExpositions;

	if(medicalColor) {
		document.documentElement.style.setProperty('--tc-medical-color', medicalColor);
	}
	if(accidentsColor) {
		document.documentElement.style.setProperty('--tc-accidents-color', accidentsColor);
	}
	if(agressionsColor) {
		document.documentElement.style.setProperty('--tc-agressions-color', agressionsColor);
	}
	if(cabinetColor) {
		document.documentElement.style.setProperty('--tc-cabinet-color', cabinetColor);
	}
	if(expositionsColor) {
		document.documentElement.style.setProperty('--tc-expositions-color', expositionsColor);
	}

	let currentThematique;
	let currentColor;

	if(document.getElementById('summary-post')) {
		currentThematique = document.getElementById('summary-post').dataset.currentColor;
	}

	if(document.getElementById('current-form')) {
		currentThematique = document.getElementById('current-form').dataset.currentColor;
	}

	switch(currentThematique) {
		case 'medical':
			currentColor = medicalColor;
			break;
		case 'accidents':
			currentColor = accidentsColor;
			break;
		case 'agressions':
			currentColor = agressionsColor;
			break;
		case 'expositions':
			currentColor = expositionsColor;
			break;
		default:
			currentColor = cabinetColor;
	}
	document.documentElement.style.setProperty('--tc-current-color', currentColor);

	//------------- Hero dynamic height --------------
	let sectionHeroHeight = document.querySelector('.hero-section');

	if(sectionHeroHeight && window.innerWidth >= 1024) {
		document.documentElement.style.setProperty('--tc-hero-height', sectionHeroHeight.offsetHeight + 'px');
	}

	//------------- Article dynamic height --------------
	let asideHeight = document.querySelector('.aside-section');

	if(asideHeight && window.innerWidth >= 1024) {
		document.documentElement.style.setProperty('--tc-aside-height', asideHeight.offsetHeight + 'px');
	}

	// ----------- Toc Summary -------------
	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}

	// ----------- Mobile CTA visibility -------------
	if(contactFormObserver) {
		contactFormObserver.disconnect();
		contactFormObserver = null;
	}

	const contactForm = document.getElementById('contactFormSection');
	const mobileCta = document.querySelector('.mobile-cta');

	if(contactForm && mobileCta) {
		contactFormObserver = new IntersectionObserver(([entry]) => {
			mobileCta.classList.toggle('is-form-visible', entry.isIntersecting);
		}, { threshold: 0.15 });

		contactFormObserver.observe(contactForm);
	}
	else if(mobileCta) {
		mobileCta.classList.remove('is-form-visible');
	}
});
